import { IBookingCalendarStore } from '../index'

export default function(state: IBookingCalendarStore): IBookingCalendarStore {
  return {
    ...state,
    roomModal: {
      ...state.roomModal,
      updateForm: {
        ...state.roomModal.updateForm,
        roomId: null,
      },
    },
  }
}
